import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc); // Enable UTC plugin

// Define the data type
interface SessionData {
  id: string;
  case: {
    title: string;
    nextSittingDate: string;
    court: {
      title: string;
      division: {
        name: string;
      };
      judge: {
        firstName: string;
        middleName?: string | null;
        lastName: string;
      };
    };
  };
}

// Define table columns
const columns: ColumnsType<SessionData> = [
  {
    title: "Case Title",
    dataIndex: "case",
    key: "caseTitle",
    render: (caseData) => caseData?.title || "N/A",
  },
  {
    title: "Court Division",
    dataIndex: "case",
    key: "courtDivision",
    render: (caseData) => caseData?.court?.division?.name || "N/A",
  },
  {
    title: "Court Name",
    dataIndex: "case",
    key: "courtName",
    render: (caseData) => caseData?.court?.title || "N/A",
  },
  {
    title: "Judge Name",
    dataIndex: "case",
    key: "judgeName",
    render: (caseData) => {
      const judge = caseData?.court?.judge;
      return judge
        ? `Justice ${judge.firstName} ${judge.middleName ? judge.middleName + " " : ""}${judge.lastName}`
        : "N/A";
    },
  },
  {
    title: "Next Sitting Date & Time (UTC)",
    dataIndex: "case",
    key: "nextSittingDate",
    render: (caseData) =>
      caseData?.nextSittingDate
        ? dayjs(caseData.nextSittingDate).utc().format("YYYY-MM-DD HH:mm [UTC]")
        : "N/A",
  },
];

const CaseTable: React.FC = () => {
  const [sessions, setSessions] = useState<SessionData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    fetch("https://backend-kyw8.onrender.com/session/upcoming")
      .then((response) => response.json())
      .then((data) => {
        setSessions(data.sessions || []); // Ensure 'sessions' exists
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching sessions:", error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="mt-20 p-6 bg-gray-100 min-h-screen custom-scrollable-table">
      <p className="form-header">Upcoming Cases</p>
      <Spin spinning={loading}>
        <Table 
          dataSource={sessions} 
          columns={columns} 
          rowKey="id"
          className="custom-table ant-table"
          pagination={{ pageSize: 10 }}
        />
      </Spin>
    </div>
  );
};

export default CaseTable;
